import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const About = lazy(() => import('../components/ScrollyPage/About'));

export const Route = createFileRoute('/om/om')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <About />
            </Suspense>
        </ScrollyArticle>
    );
}
